import React from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import FormikInputField from 'components/forms/fields/FormikInputField';
import Button from 'components/buttons/Button';
import axios from 'data/axios';
import toast from 'react-hot-toast';

const initialValues = {
    email: ''
};

const schema = Yup.object().shape({
    email: Yup.string().required('Vnesi e-poštni naslov s katerim si ustvaril KZV račun.')
});

const ForgotPasswordForm = ({ onSuccess }: { onSuccess: () => void }) => {
    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            await axios.post('/public/reset-password', values);
            onSuccess();
            setSubmitting(false);
        } catch (e) {
            setSubmitting(false);
            toast.error('Prišlo je do napake. Osveži stran in poskusi znova.');
        }
    };

    return (
        <>
            <Formik
                initialValues={initialValues}
                validationSchema={schema}
                onSubmit={handleSubmit}
                validateOnBlur={true}
            >
                {({ isSubmitting, handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <FormikInputField
                            name="email"
                            label="E-pošta"
                            type={'email'}
                            placeholder="Vnesi e-poštni naslov"
                            autocomplete="username"
                        />
                        <div className="flex flex-col mt-4">
                            <Button color={'secondary'} variant={'contained'} type={'submit'} disabled={isSubmitting}>
                                <span className="font-bold">Ponastavi svoje geslo</span>
                            </Button>
                        </div>
                    </form>
                )}
            </Formik>
        </>
    );
};

export default ForgotPasswordForm;
